module.exports = __webpack_public_path__ + "img/planet.07812fe8.svg";